
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface TransactionInstallmentToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  paymentMethod: string;
}

export const TransactionInstallmentToggle = ({ 
  value, 
  onChange, 
  disabled, 
  paymentMethod 
}: TransactionInstallmentToggleProps) => {
  // Allow installments for all payment methods
  const isSupported = true;

  return (
    <div className="flex items-center justify-between">
      <div>
        <Label htmlFor="installment-toggle">Parcelar transação</Label>
      </div>
      <Switch
        id="installment-toggle"
        checked={value && isSupported}
        onCheckedChange={onChange}
        disabled={disabled || !isSupported}
      />
    </div>
  );
};
